export default __webpack_public_path__ + "static/media/Teeth of the Drowned.0ed98c9b.jpg";